import { fetchCurrentUser } from '../../ducks/user.duck';
import { searchGroupsApi, searchSpaceGroupsApi } from '../../util/api';
import { EXPLORE } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import {
    fetchSpaceList,
    onGetCircleAuthToken,
    setActiveTab
} from '../CircleCommunityPage/CircleCommunityPage.duck';

export const REQUEST_SEARCH_GROUPS = 'app/GroupSearchPage/REQUEST_SEARCH_GROUPS';
export const SUCCESS_SEARCH_GROUPS = 'app/GroupSearchPage/SUCCESS_SEARCH_GROUPS';
export const ERROR_SEARCH_GROUPS = 'app/GroupSearchPage/ERROR_SEARCH_GROUPS';
export const REQUEST_SPACE_GROUPS = 'app/GroupSearchPage/REQUEST_SPACE_GROUPS';
export const SUCCESS_SPACE_GROUPS = 'app/GroupSearchPage/SUCCESS_SPACE_GROUPS';
export const ERROR_SPACE_GROUPS = 'app/GroupSearchPage/ERROR_SPACE_GROUPS';
export const REQUEST_ACCESS_TOKEN = 'app/GroupSearchPage/REQUEST_ACCESS_TOKEN';
export const SUCCESS_ACCESS_TOKEN = 'app/GroupSearchPage/SUCCESS_ACCESS_TOKEN';
export const ERROR_ACCESS_TOKEN = 'app/GroupSearchPage/ERROR_ACCESS_TOKEN';

const initialState = {
    requestSearchGroups: false,
    searchGroupsData: null,
    errorSearchGroups: null,
    requestSpaceGroups: false,
    spaceGroupsData: null,
    errorSpaceGroups: null,
    loadMoreSearchGroups: false,
    requestAccessToken: false,
    accessToken: null,
    errorAccessToken: null
};

export default function groupSearchPageReducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
      case REQUEST_SEARCH_GROUPS:
        return {
          ...state,
          requestSearchGroups: payload.page <= 1,
          loadMoreSearchGroups: payload.page > 1,
          //searchGroupsData: payload
        };
      case SUCCESS_SEARCH_GROUPS:
        const { data } = payload;
        const { page, records } = data;
        return {
          ...state,
          requestSearchGroups: false,
          loadMoreSearchGroups: false,
          searchGroupsData: {
            ...data,
            records: page > 1 ? [...state.searchGroupsData.records, ...records] : records,
          },
        };
      case ERROR_SEARCH_GROUPS:
        return {
          ...state,
          requestSearchGroups: false,
          loadMoreSearchGroups: false,
          searchGroupsData: null,
          errorSearchGroups: payload.error,
        };
      case REQUEST_SPACE_GROUPS:
        return { ...state, requestSpaceGroups: true };
      case SUCCESS_SPACE_GROUPS:
        return { ...state, requestSpaceGroups: false, spaceGroupsData: payload.data };
      case ERROR_SPACE_GROUPS:
        return {
          ...state,
          requestSpaceGroups: false,
          spaceGroupsData: null,
          errorSpaceGroups: payload.error,
        };
      case REQUEST_ACCESS_TOKEN:
        return { ...state, requestAccessToken: true };
      case SUCCESS_ACCESS_TOKEN:
        return { ...state, requestAccessToken: false, accessToken: payload.data };
      case ERROR_ACCESS_TOKEN:
        return {
          ...state,
          requestAccessToken: false,
          accessToken: null,
          errorAccessToken: payload.error,
        };
      default:
        return state;
    }
}

export const requestSearchGroups = (page) => ({
    type: REQUEST_SEARCH_GROUPS,
    payload: { page },
});
export const successSearchGroups = data => ({
    type: SUCCESS_SEARCH_GROUPS,
    payload: { data },
});
export const errorSearchGroups = error => ({
    type: ERROR_SEARCH_GROUPS,
    payload: { error },
});

export const requestSpaceGroups = () => ({
    type: REQUEST_SPACE_GROUPS,
});
export const successSpaceGroups = data => ({
    type: SUCCESS_SPACE_GROUPS,
    payload: { data },
});
export const errorSpaceGroups = error => ({
    type: ERROR_SPACE_GROUPS,
    payload: { error },
});

export const requestAccessToken = () => ({
  type: REQUEST_ACCESS_TOKEN,
});
export const successAccessToken = data => ({
  type: SUCCESS_ACCESS_TOKEN,
  payload: { data },
});
export const errorAccessToken = error => ({
  type: ERROR_ACCESS_TOKEN,
  payload: { error },
});

export const searchGroups = params => async (dispatch, getState, sdk) => {
    const { page = 1, sort = '', keyword = '', space_group = '' } = params;
    try {
        dispatch(requestSearchGroups(page));
        const email = getState()?.user?.currentUser?.attributes?.email;
        const { access_token,success, message } = await onGetCircleAuthToken(email);  
        dispatch(successAccessToken(access_token ?? {success, message}));
        const response = await searchGroupsApi({
            accessToken: access_token,
            page: page,
            sort: sort,
            keyword,
            type: 'spaces',
            space_group,
        });
        dispatch(successSearchGroups({ ...response, sort, keyword }));
        return response;
    } catch (e) {
        console.log(e, '&&& &&& => e');
    }
};

export const searchSpaceGroups = params => async (dispatch, getState, sdk) => {
    try {
        dispatch(requestSpaceGroups());
        const email = getState()?.user?.currentUser?.attributes?.email;
        const { access_token } = await onGetCircleAuthToken(email);
        const response = await searchSpaceGroupsApi({
            accessToken: access_token
        })
        dispatch(successSpaceGroups(response));
        return response
    } catch (error) {
        console.log(e, '&&& &&& => e');
        dispatch(errorSpaceGroups(e))
    }
}

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
    const { page = 1, sort = 'latest', keyword = '' } = parse(search);
    console.log('keyword', keyword)
    const { currentUser } = getState().user;
    if (!currentUser) {
        return dispatch(fetchCurrentUser()).then(() => {
            return Promise.all([dispatch(searchGroups({ page: +page })), dispatch(fetchSpaceList())]);
        });
    }

    // If `currentUser` already exists, directly execute Promise.all
    return Promise.all([
        dispatch(searchGroups({ page: +page, keyword: keyword })),
        dispatch(searchSpaceGroups()), dispatch(setActiveTab(EXPLORE)),
    ]);
};
